export function normalizeSourceFileId(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    return String(value);
}

export function buildSourcesViewKey(activeView, currentFolderId) {
    if (!activeView || activeView.type === 'root') {
        return 'root';
    }

    if (activeView.type === 'preset') {
        return `preset:${activeView.id || activeView.branch || 'unknown'}`;
    }

    if (activeView.type === 'folder') {
        return `folder:${activeView.branch || 'root'}:${currentFolderId || activeView.id || 'unknown'}`;
    }

    return 'root';
}

export function isSourceFileSelected({
    fileId,
    selectedFileId,
    currentViewKey,
    selectedFileSourceViewKey,
}) {
    return normalizeSourceFileId(fileId) === normalizeSourceFileId(selectedFileId)
        && selectedFileSourceViewKey === currentViewKey;
}

export function buildSourceViewerPayload({
    reportId,
    file,
    sourceFolderId,
    sourceViewKey,
}) {
    return {
        reportId,
        fileId: normalizeSourceFileId(file?.id),
        canonicalFileId: normalizeSourceFileId(file?.referencedDataItemId) || null,
        fileName: file?.name || null,
        fileType: file?.fileType || 'unknown',
        fileSource: file?.source || null,
        sourceFolderId,
        sourceViewKey,
    };
}

